import { useEffect } from 'react';
import {
    useLocation,
    useNavigate,
    useParams
  } from "react-router-dom";

export const withKeyHoldersDefaultRoute = (Component) =>  {
    const WithKeyHoldersDefaultRouteWrapper = (props) => {
		const location = useLocation();
		const navigate = useNavigate();
		const params = useParams();
		const match = {
			path: location.pathname
		};
		
		useEffect(() => {
			// if the default page has been requested
			var defaultRegex = /\/buildingaccess\/reports\/keyholders$/i;
			if (defaultRegex.test(match.path)) {
				navigate(match.path + '/Parameters', { replace: true });
			}
		});
		
		return (
			<Component
				location={location}
				navigate={navigate}
				params={params}
				match={match}
				{...props}
			/>
		);
    }
    return WithKeyHoldersDefaultRouteWrapper;
}
